import * as React from 'react';
export const oberbankSvg = React.forwardRef(function oberbankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E53527',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M16.06 26.18c-5.94 0-10.24-3.93-10.24-9.45 0-5.5 4.27-9.46 10.18-9.46 5.96 0 10.18 3.68 10.18 9.46 0 5.55-4.4 9.45-10.12 9.45zM16 10.72a5.67 5.67 0 0 0-5.82 6 5.56 5.56 0 0 0 5.8 5.88c3.34 0 5.84-2.05 5.84-5.87 0-3.96-2.62-6.01-5.82-6.01z',
      }),
    ),
  );
});
oberbankSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var oberbank = {
  category: 'brand',
  colorable: false,
  name: 'oberbank',
  svg: oberbankSvg,
};
